(function () {
  let template = document.querySelector('.featured-collection__container').getAttribute('data-template');
  if (template === 'cart') {
    removeProductsAlreadyInCart();
  }
  function handleProductGridItem() {
    let allFeaturedCollections = document.querySelectorAll('.featured-collection__content');
    var productCount = 0;
    allFeaturedCollections.forEach((section) => {
      let productItems = section.querySelectorAll('.productgrid--item:not(.featured-collection__title-card)');
      let width = window.innerWidth;
      //console.log(width);
      if (width < 767) {
        productCount = parseInt(section.dataset.productCountMobile, 10);
      } else {
        productCount = parseInt(section.dataset.productCountDesktop, 10);
      }
      productItems.forEach((item, index) => {
        if (index >= productCount) {
          item.style.display = 'none';
        }
      });
    });
  }
  async function removeProductsAlreadyInCart() {
    let cartJson = await fetch(`${window.Theme.routes.cart_url}.js`).then((res) => res.json());
    const IdsInCart = cartJson.items.map((i) => {
      return i.product_id;
    });
    if (IdsInCart.length > 0) {
      document.querySelectorAll('.featured-collection__container .productitem').forEach((item) => {
        for (id of IdsInCart) {
          console.log(item.dataset.productId);
          if (item.dataset.productId === id.toString().trim()) {
            console.log('item is in cart');
            item.parentElement.classList.add('hide');
          }
        }
      });
    }
  }
  handleProductGridItem();

  window.addEventListener('load', handleProductGridItem);
  window.addEventListener('resize', handleProductGridItem);
})();
